import { CarouselAlign } from '@/page-sections/CarouselAlign';
import { CarouselSmall } from '@/page-sections/CarouselSmall';
import { Details } from '@/page-sections/Details';
import { FaqsView } from '@/page-sections/faqs/view';
import { Gallery } from '@/page-sections/Gallery';
import { GridComponent } from '@/page-sections/GridComponent';
import { Hero } from '@/page-sections/Hero';
import { HeroContact } from '@/page-sections/HeroContact';
import { HeroHome } from '@/page-sections/HeroHome';
import { Highlights } from '@/page-sections/Highlights';
import { ListComponent } from '@/page-sections/ListComponent';
import { Map } from '@/page-sections/Map';
import { SimpleAction } from '@/page-sections/SimpleAction';
import { Team } from '@/page-sections/Team';
import { Testimonials } from '@/page-sections/Testimonials';

import { CarouselCards } from './CarouselCards';
import { ChipsComponent } from './ChipsComponent';
import { GridTextComponent } from './GridTextComponent';

export const SectionsComponents: Record<string, any> = {
  SectionsComponentsDevicelocationsLayout: Map,
  SectionsComponentsTeamLayout: Team,
  SectionsComponentsHeroLayout: Hero,
  SectionsComponentsHeroHomeLayout: HeroHome,
  SectionsComponentsHeroContactLayout: HeroContact,
  SectionsComponentsTestimonialsLayout: Testimonials,
  SectionsComponentsCarouselalignLayout: CarouselAlign,
  SectionsComponentsCarouselcardsLayout: CarouselCards,
  SectionsComponentsCarouselsmallLayout: CarouselSmall,
  SectionsComponentsGridLayout: GridComponent,
  SectionsComponentsGridtextLayout: GridTextComponent,
  SectionsComponentsListLayout: ListComponent,
  SectionsComponentsSimpleactionLayout: SimpleAction,
  SectionsComponentsFaqsLayout: FaqsView,
  SectionsComponentsGalleryLayout: Gallery,
  SectionsComponentsHighlightslightLayout: Highlights,
  SectionsComponentsDetailsLayout: Details,
  SectionsComponentsChipsLayout: ChipsComponent,
};
